<template>
  <div class="border rounded bg-body-emphasis mt-3 overflow-hidden">
    <DataTable
      :value="rows"
      dataKey="id"
      selectionMode="single"
      tableClass="table table-hover mb-0"
      @row-select="emit('select', $event.data)"
    >
      <template #empty>No conversations match these filters.</template>
      <Column header="Started" bodyClass="ps-3"
        ><template #body="{ data }">{{
          formatDateTime(data.created_at)
        }}</template></Column
      >
      <Column header="Type"
        ><template #body="{ data }">{{
          conversationTypeLabel(data.conversation_type)
        }}</template></Column
      >
      <Column header="Company"
        ><template #body="{ data }"
          ><span class="truncate" :title="data.company.name">{{
            data.company.name
          }}</span
          ><span
            v-if="data.company.deleted"
            class="badge bg-secondary-subtle text-secondary-emphasis ms-1"
            >Archived</span
          ></template
        ></Column
      >
      <Column header="Account"
        ><template #body="{ data }"
          ><span class="truncate" :title="data.account.email">{{
            data.account.email
          }}</span
          ><span
            v-if="data.account.is_staff"
            class="badge bg-secondary-subtle text-secondary-emphasis ms-1"
            >Soldera</span
          ></template
        ></Column
      >
      <Column field="inferred_turn_count" header="Inferred turns" />
      <Column field="upload_count" header="Files" />
      <Column header="Outcome"
        ><template #body="{ data }"
          ><span class="badge" :class="outcomePill(data.outcome).className">{{
            outcomePill(data.outcome).label
          }}</span></template
        ></Column
      >
      <Column header="ID"
        ><template #body="{ data }"
          >#{{ data.id
          }}<span
            v-if="data.deleted"
            class="badge bg-secondary-subtle text-secondary-emphasis ms-1"
            >Archived</span
          ></template
        ></Column
      >
    </DataTable>
    <p v-if="moreFailed" class="text-danger small p-3 mb-0" role="alert">
      Could not load older conversations. Try again.
    </p>
    <button
      v-if="hasMore"
      class="btn btn-link w-100"
      :disabled="loadingMore"
      @click="emit('more')"
    >
      {{ loadingMore ? "Loading…" : "Load more" }}
    </button>
  </div>
</template>
<script setup lang="ts">
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { formatDateTime } from "@/composables/formatUtils";
import type { AiConversationRow } from "./aiConversationsTypes";
import {
  conversationTypeLabel,
  outcomePill,
} from "./aiConversationsPresenters";
defineProps<{
  rows: AiConversationRow[];
  hasMore: boolean;
  loadingMore: boolean;
  moreFailed: boolean;
}>();
const emit = defineEmits<{ select: [row: AiConversationRow]; more: [] }>();
</script>
<style scoped lang="scss">
.truncate {
  display: inline-block;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
:deep(tbody tr) {
  cursor: pointer;
}
</style>
